import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  namespaced: true,
  state: {
    dataSources: [],
    totalRows: 0,
    studentsIneligible: [],
    teachingExam: {},
    studentsNotEligible: [],
  },
  getters: {
    dataSources: state => state.dataSources,
    totalRows: state => state.totalRows,
    studentsIneligible: state => state.studentsIneligible,
    teachingExam: state => state.teachingExam,
    studentsNotEligible: state => state.studentsNotEligible,
  },
  mutations: {
    SET_DATA_SOURCES: (state, { total, records }) => {
      state.totalRows = total
      state.dataSources = records
    },
    SET_DATA_PRINT: (state, { teachingExam, studentsIneligible }) => {
      state.teachingExam = teachingExam
      state.studentsIneligible = studentsIneligible
    },
    SET_STUDENT: (state, studentsNotEligible) => {
      state.studentsNotEligible = studentsNotEligible
    },
  },
  actions: {
    async getDataSources({ commit }, params) {
      try {
        const response = await axios.get('uni/reports/reportTeachingExamCondition', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, records } = data.data
          commit('SET_DATA_SOURCES', { total, records })
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getDataPrint({ commit }, params) {
      try {
        const response = await axios.get('uni/reports/reportTeachingExamCondition/print', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { teachingExam, studentsIneligible } = data.data
          commit('SET_DATA_PRINT', { teachingExam, studentsIneligible })
        }
        return null
      } catch (e) {
        handleCatch(e)
      }
      return null
    },

    async getStudentsNotEligible({ commit }, params) {
      try {
        const response = await axios.get('uni/reports/reportStudentNotEligible', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_STUDENT', data.data)
        }
        return null
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
